import { PrimeReactProvider } from 'primereact/api';
import 'primereact/resources/primereact.css';
import ReactDOM from 'react-dom/client';
import './core/api/axiosInterceptor';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import React from 'react';

import '@/styles/index.scss';
import './flags.css';
import App from './App';
import { initializeTheme } from './shared/model/theme';

initializeTheme();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <App />
    </PrimeReactProvider>
  </React.StrictMode>
);
